export const payPeriodStatusValues = ['open', 'closed'] as const;
export type PayPeriodStatus = (typeof payPeriodStatusValues)[number];

export interface PayPeriodDto {
  id: string;
  companyId: string;
  startDate: string;
  endDate: string;
  status: PayPeriodStatus;
  closedAt: string | null;
  closedByUserId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface GetCurrentPayPeriodRequest {
  companyId: string;
}

export interface GetCurrentPayPeriodResponse {
  payPeriod: PayPeriodDto;
}

export interface ClosePayPeriodRequest {
  companyId: string;
  payPeriodId: string;
}

export interface ClosePayPeriodResponse {
  payPeriod: PayPeriodDto;
}

